import { window, head } from "./window.js";
import { append } from "./modify.js";
import { createElement } from "./create.js";
export const classList = (element) => element.classList;
export const addClass = (element, ...tokens) => element.classList.add(...tokens);
export const removeClass = (element, ...tokens) => element.classList.remove(...tokens);
export const hasClass = (element, token) => element.classList.contains(token);
export const toggleClass = (element, token, force) => element.classList.toggle(token, force);
export const setStyle = (element, property, value, priority) => element.style.setProperty(property, value, priority);
export const getStyle = (element, property) => element.style.getPropertyValue(property);
export const getComputedStyleValue = (element, property) => window.getComputedStyle(element).getPropertyValue(property);
export const show = (element) => setStyle(element, "display", "");
export const hide = (element) => setStyle(element, "display", "none", "important");
export const createStylesheet = (href) => new Promise((resolve, reject) => {
    const link = createElement("link");
    link.onload = () => resolve(link);
    link.onerror = reject;
    link.rel = "stylesheet";
    link.href = href;
    append(head, link);
});
